<template>
  <div class="order-mask" v-if="negative.negativeFlag">
    <!-- 上传底片 -->
    <div class="mask-main">
      <div class="mask-nav">
        <div class="mask-title">
          <div></div>
          {{ negative.title }}
        </div>
        <i @click="handleRefund" class="el-icon-close"></i>
      </div>
      <div class="table">
        <el-input type="textarea" :placeholder="negative.name" v-model="textarea" :maxlength="negative.maxlength"
          :disabled="negative.disabled" show-word-limit>
        </el-input>
        <div class="btns">
          <div v-if="negative.btn != ''" class="save1" @click="handleSubmit">{{ negative.btn }}</div>
          <div v-if="negative.btn1 && negative.btn1 != ''" class="save1 save2" @click="handleRefund">{{ negative.btn1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "FailureReason",
  props: ["negative"],
  data() {
    return {
      textarea: "",
    };
  },
  mounted() { },
  methods: {
    //取消弹窗
    handleRefund() {
      let obj = {
        negativeFlag: false,
        submitFlag: false,
      }
      this.$emit("negativeCell", obj);
    },
    handleSubmit() {
      let obj = {
        negativeFlag: false,
        submitFlag: true,
        typeText: this.textarea
      }
      this.$emit("negativeCell", obj);
    },
  },
  watch: {
    negative: {
      deep: true,
      handler(newVal, oldVal) {
        //  console.log(newVal);
        this.textarea = newVal.reason
      }
    }
  }
};
</script>
    
<style lang="less" scoped>
@import url("@/assets/css/mask.less");

/deep/.table {
  padding-top: 1.852vh;

  textarea {
    height: 33.333vh;
    resize: none;
  }
}

/deep/.el-textarea__inner {
  padding: 0.26vw 0.781vw;
  border: 0.052vw solid #DCDFE6;
  border-radius: 0.208vw;
}
</style>